
import { computed, defineComponent, useCssModule } from 'vue'

export default defineComponent({
	props: {
		title: {
			type: String,
			required: false,
		},
		titleColor: {
			type: String,
			required: false,
		},
		hideContent: {
			type: Boolean,
			default: false,
		},
	},
	setup: ({ title, titleColor, hideContent }) => ({
		style: useCssModule(),
		title,
		titleStyle: computed(() => (
			titleColor ? {
				backgroundColor: titleColor,
			} : {
			}
		)),
		hideContent,
	})
})
